module.exports = __webpack_public_path__ + "img/bean_header.19c5cda3.png";